import React from 'react';
import { useTranslation } from 'react-i18next';

import { BodyText } from '@chargify/custom-ui-components';
import { Wrapper } from './PlanRadio.styles';
import { Status } from './components/Status/Status';
import { Price } from './components/Price/Price';

type PlanRadioProps = {
  id: number;
  name: string;
  price: string;
  interval: number;
  intervalUnit: string;
  selected: boolean;
  onClick: (id: number) => void;
  isCurrentPlan: boolean;
};

export const PlanRadio = ({
  selected,
  onClick,
  name,
  id,
  isCurrentPlan,
  price,
  intervalUnit,
}: PlanRadioProps) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <Wrapper selected={selected} paddingY={6} paddingX={7}>
      <input
        type={'radio'}
        hidden={true}
        checked={selected}
        onChange={() => onClick(id)}
      />
      <BodyText variant={'body1'}>{name}</BodyText>
      {isCurrentPlan && <Status text={t('plan_change.current')} />}
      <Price price={price} intervalUnit={intervalUnit} />
    </Wrapper>
  );
};
